module.exports = __webpack_public_path__ + "img/5.86ec4a26.jpg";